<template>
  <v-dialog
    persistent
    v-model="showDialogStore"
    max-width="900"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title primary-title class="headline orange">
        <v-layout column>
          <span class="title font-weight-light white--text">Add Extra</span>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-form ref="extraForm" v-model="valid">
          <v-layout style="width: 100%" row wrap pb-2 pt-3>
            <v-flex xs6 md6 px-3>
              <v-text-field
                :rules="[validators.required]"
                v-model="extra.invoice_id"
                label="Invoice Reference"
                @input
                :disabled="true"
              />
            </v-flex>
            <v-flex xs6 md6 px-3>
              <v-text-field
                :rules="[]"
                v-model="extra.booking_id"
                label="Booking Reference"
                @input
                :disabled="true"
              />
            </v-flex>
            <v-flex xs6 md6 px-3>
              <v-text-field
                :rules="[validators.required]"
                v-model="extra.description"
                label="Description"
                maxlength="500"
                counter="500"
                @input
              />
            </v-flex>
            <v-flex xs6 md6 px-3>
              <v-text-field
                :rules="[validators.required]"
                v-model="extra.driver_description"
                label="Driver Description"
                maxlength="500"
                counter="500"
                @input
              />
            </v-flex>
            <v-flex xs6 md6 px-3>
              <SimpleCurrencyInput
                :flat="false"
                :singleLine="false"
                :solo="false"
                :extraLabel="false"
                backgroundColour
                width="140px;"
                v-model="extra.amount"
                label="Amount"
              />
            </v-flex>
            <v-flex xs6 md6 px-3>
              <v-select
                :items="chargeDirections"
                item-text="name"
                item-value="value"
                :rules="[]"
                v-model="extra.credit"
                label="Transaction Type"
                @input
              />
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" class="text-none" text outlined @click="cancel()">Cancel</v-btn>
        <v-btn color="blue darken-1" class="text-none" text outlined @click="add()">Add Extra</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SimpleCurrencyInput from "@/components/widget/input/SimpleCurrencyInput.vue";

export default {
  name: "add_extra",
  components: {
    SimpleCurrencyInput
  },
  props: {
    showDialog: Boolean,
    invoiceID: Number,
    bookingID: Number
  },
  data: function() {
    return {
      showDialogStore: false,
      extra: {
        invoice_id: "",
        booking_id: "",
        description: "",
        driver_description: "",
        amount: "",
        credit: true
      },
      valid: true,
      chargeDirections: [
        { name: "Credit", value: true },
        { name: "Debit", value: false }
      ],
      validators: {
        money: v => /^\d+\.?\d?\d?$/.test(v) || "Please enter a valid amount",
        moreThanZero: v => v > 0 || "Please enter an amount more than zero",
        required: v => !!v || "This field is required"
      }
    };
  },
  methods: {
    cancel: function() {
      this.$emit("closeAddExtra");
      this.extra = {
        invoice_id: "",
        booking_id: "",
        description: "",
        driver_description: "",
        amount: "",
        credit: true
      };
      this.$refs.extraForm.resetValidation();
    },
    add: function() {
      if (this.valid) {
        this.$emit("addExtra", this.extra);
        this.cancel();
      } else {
        this.$refs.extraForm.validate();
      }
    }
  },
  mounted: function() {
    this.extra.invoice_id = this.invoiceID;
    this.extra.booking_id = this.bookingID;
  },
  watch: {
    invoiceID: function() {
      this.extra.invoice_id = this.invoiceID;
    },
    bookingID: function() {
      this.extra.booking_id = this.bookingID;
    },
    showDialog: function() {
      this.showDialogStore = this.showDialog;
    },
    showDialogStore: function() {
      if (!this.showDialogStore) {
        this.cancel();
      }
    }
  }
};
</script>

<style>
</style>
